import React from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import CreditCardIcon from '../../icons/IconLib/CreditCardIcon';
import { PAYMENT_TYPE, PaymentType } from '../../../main/second/mainbar/receipt/generic/getDetailesByPaymentType';

/** Payment type filter: '' — all types. */
export const PAYMENT_TYPE_ALL = '' as const;

export type PaymentTypeFilterValue = PaymentType | typeof PAYMENT_TYPE_ALL;

interface IPaymentTypeOption {
    value: PaymentTypeFilterValue;
    label: string;
}

interface Props {
    value: PaymentTypeFilterValue;
    onSelect: (value: PaymentTypeFilterValue) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    leadingIcon?: React.ReactNode | null;
    className?: string;
}

const OPTIONS: IPaymentTypeOption[] = [
    { value: PAYMENT_TYPE_ALL, label: 'הכל' },
    ...(Object.keys(PAYMENT_TYPE) as PaymentType[]).map((code) => ({ value: code, label: PAYMENT_TYPE[code].name })),
];

const PaymentTypeSelector: React.FC<Props> = ({
    value,
    onSelect,
    placeholder = 'בחר אמצעי תשלום',
    disabled,
    readOnly,
    leadingIcon,
    className,
}) => (
    <SearchableSelect<IPaymentTypeOption>
        items={OPTIONS}
        value={OPTIONS.find((o) => o.value === value) ?? null}
        onSelect={(o) => onSelect(o?.value ?? PAYMENT_TYPE_ALL)}
        getKey={(o) => o.value}
        getLabel={(o) => o.label}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={leadingIcon === undefined ? <CreditCardIcon /> : leadingIcon}
        className={className}
        emptyLabel='לא נמצא דבר'
    />
);

export default PaymentTypeSelector;
